import React from 'react';
import { Box, Inscription, WarningLabel } from '@common-fe/common-fe';

import { StatusWrapper } from '@/components';

export const EmployerReactivationBankListPlaceholder = () => {
  return (
    <Box margin={{ top: 'spacing16' }}>
      <StatusWrapper status="pending" isWithShadow={false}>
        <Box
          margin="spacing12"
          pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
          background={{ color: 'warningContainer' }}
          border={{ size: '1px', color: 'warningBorder' }}
          round="fieldRound"
        >
          <Inscription weight="bold" margin={{ bottom: 'spacing8' }} color="textBody">
            <WarningLabel>
              Add a bank account first
            </WarningLabel>
          </Inscription>

          <Box>
            <Inscription
              data-testid="EmployerReactivationBankListPlaceholder_confirm_message"
              margin={{ bottom: 'spacing8' }}
              color="textBody"
              size="14px"
            >
              Bank accounts are cleared during employer termination. Please add a bank details to reactivate this organization and continue with configuration.
            </Inscription>
          </Box>
        </Box>
      </StatusWrapper>
    </Box>
  );
};
